export default __webpack_public_path__ + "static/media/jwl-3.6c706d5e.png";